import { getSelectorFromElement, onSelect, onSelectAll } from './utils/dom'
import { onAutoFitInput, onFocusInput } from './forms'
import './components/tabs-clients'
import './components/counter'
import './components/follow-cursor'
import './components/solutions-hover'
import './components/dropdown'
import './animations/animations'
import './scroll'
import './swiper'
import { onToggle } from './utils/class-list'

// ** general functions project - start ** //
/**
 * foused inputs of forms
 */
const FOUSED_INPUTS = ['#email-signup_FNAME', '#email-signup_LNAME', '#email-signup_email_address', '.form-module .form-module__field input', '.bl-login-form .bl-login-form__field.field--label input']

FOUSED_INPUTS.forEach((selectorInputs) => {
  if (selectorInputs === '') return

  let nodesInputs = onSelectAll(selectorInputs)
  onFocusInput(nodesInputs)
  onAutoFitInput(nodesInputs)
})

/**
 * onOverflow
 */

function onOverflow(selector) {
  onSelectAll(selector).forEach((element) => {
    let selector = getSelectorFromElement(element, 'data-js-overflow')

    if (selector) {
      let target = onSelect(selector)

      element.addEventListener('click', function (event) {
        event.preventDefault()

        onToggle(target, 'overflow-element')
      })
    }

    return null
  })
}

/**
 * * removeTags
 * remove empty tags
 */
const removeTags = () => {
  const paragraph = onSelectAll('p') || []
  paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))
}

// load window
window.addEventListener('load', () => {
  removeTags()
  onOverflow('[data-js-overflow]')
})
// ** general functions project - end ** //
